import { render, staticRenderFns } from "./BaseParagraphInput.vue?vue&type=template&id=59fc0978"
import script from "./BaseParagraphInput.vue?vue&type=script&lang=js"
export * from "./BaseParagraphInput.vue?vue&type=script&lang=js"
import style0 from "./BaseParagraphInput.vue?vue&type=style&index=0&id=59fc0978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports